import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

const faqs = [
  {
    q: "Intervenez-vous en dehors de l'Île-de-France ?",
    a: "Oui. Basés en Île-de-France, nous nous déplaçons partout en France et dans toute l'Europe pour vos événements. Les frais de déplacement sont simplement à la charge du client.",
    testid: "faq-item-zone",
  },
  {
    q: "Comment obtenir un devis ?",
    a: "Contactez-nous sur WhatsApp ou via le formulaire de devis : indiquez la date, le lieu et le nombre d'invités. Vous recevez une réponse rapide avec un tarif clair et sans engagement.",
    testid: "faq-item-devis",
  },
  {
    q: "Vos serveurs arrivent-ils avec leur tenue ?",
    a: "Oui. Toute la brigade arrive en tenue d'apparat complète : chemise blanche, gilet noir, nœud papillon et serviette de service. Le maître d'hôtel coordonne l'équipe du début à la fin de votre événement.",
    testid: "faq-item-tenue",
  },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="bg-[#f9f8f6] px-6 py-28 text-[#0a0a0a] lg:px-10 lg:py-40">
      <div className="mx-auto max-w-4xl">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-6 text-[11px] font-semibold uppercase tracking-[0.4em] text-[#aa8c2c]"
        >
          Questions fréquentes
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="mb-16 font-display text-4xl leading-tight tracking-tight text-[#0a0a0a] sm:text-5xl"
        >
          Tout ce que vous devez savoir, <em className="italic text-[#aa8c2c]">avant de nous écrire.</em>
        </motion.h2>
        <div className="divide-y divide-[#0a0a0a]/10 border-y border-[#0a0a0a]/10">
          {faqs.map((f, i) => (
            <motion.div
              key={f.testid}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
            >
              <button
                type="button"
                onClick={() => setOpen(open === i ? -1 : i)}
                data-testid={f.testid}
                aria-expanded={open === i}
                className="flex w-full items-center justify-between gap-6 py-8 text-left"
              >
                <span className="font-display text-xl tracking-tight text-[#0a0a0a] sm:text-2xl">{f.q}</span>
                <Plus
                  className={`h-5 w-5 shrink-0 text-[#aa8c2c] transition-transform duration-300 ${
                    open === i ? "rotate-45" : ""
                  }`}
                />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                    className="overflow-hidden"
                  >
                    <p className="max-w-2xl pb-8 text-sm leading-relaxed text-[#0a0a0a]/60">{f.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
